import { render, staticRenderFns } from "./GlassBreakagePersonalPropertiesBelongsToMeQuestion.vue?vue&type=template&id=a682acfc"
import script from "./GlassBreakagePersonalPropertiesBelongsToMeQuestion.vue?vue&type=script&lang=ts"
export * from "./GlassBreakagePersonalPropertiesBelongsToMeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports